import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Time/TimeUsage.mdx";

import Examples from "../../Docs/Components/Time/TimeExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Time"
            description="Time can display duration, dates and points in time."
            apiSources={["azure-devops-ui/Components/Time/Time/Time.Props.d.ts", "azure-devops-ui/Components/Time/Ago/Ago.Props.d.ts", "azure-devops-ui/Components/Time/Duration/Duration.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;